import axios from "../utils/axios.wrapper";

export const getCompanyTypes = async () => {
  const { data } = await axios.get("/CompanyType/active");
  return data.items || data;
};

export const getCompanyTypeById = async (id) => {
  const { data } = await axios.get(`/CompanyType/${id}`);
  return data;
};

export const createCompanyType = async (companyType) => {
  const { data } = await axios.post("/CompanyType/create", companyType);
  return data;
};

export const updateCompanyType = async (id, companyType) => {
  const { data } = await axios.put(`/CompanyType/${id}`, companyType);
  return data;
};

export const deleteCompanyType = async (id) => {
  const { data } = await axios.delete(`/CompanyType/${id}`);
  return data;
};

export const companyTypesService = {
  getCompanyTypes,
  getCompanyTypeById,
  createCompanyType,
  updateCompanyType,
  deleteCompanyType,
};
